import GeographyFilter from "./GeographyFilter";
export default function DataFilters({ value, onChange, facets, onClear }) {
    return <div className="flex flex-wrap items-end gap-3 py-4"><GeographyFilter value={value.geography || ""} onChange={geography => onChange({geography})} extraOptions={facets.geographies || []}/>{value.geography && <button className="sdx-text-link" onClick={onClear}>Clear geography</button>}</div>;
}
